import type { ComponentType, SVGProps } from 'react'
import { routes } from '@/routes'
import { HomeIcon, IdCardIcon, ShieldIcon } from '@/components/ui/icons'

export interface ProfileNavItem {
  to: string
  label: string
  icon: ComponentType<SVGProps<SVGSVGElement>>
  /** `end` do NavLink: "Minha conta" só casa com a rota exata. */
  end: boolean
  /**
   * Só aparece a partir de `md`. "Minha conta" é o próprio destino de "Seu
   * perfil", então no celular — onde as abas viram ícones e ganham um submenu
   * no sanduíche — ela apareceria duas vezes dizendo a mesma coisa.
   */
  desktopOnly?: boolean
}

/**
 * Abas do perfil.
 *
 * Vive aqui porque aparece em dois lugares: na moldura do perfil e como
 * submenu de "Seu perfil" no menu sanduíche. Uma lista só evita que as duas
 * versões saiam do lugar uma da outra.
 */
export const PROFILE_NAV_ITEMS: ProfileNavItem[] = [
  {
    to: routes.profile,
    label: 'Minha conta',
    icon: HomeIcon,
    end: true,
    desktopOnly: true,
  },
  {
    to: routes.profilePersonalData,
    label: 'Dados pessoais',
    icon: IdCardIcon,
    end: false,
  },
  { to: routes.profileSecurity, label: 'Segurança', icon: ShieldIcon, end: false },
]
